<template>
    <div class="platform-showcase-bg">
        <div class="showcase-content-wrapper">
            <!-- Main Hook Title Headline -->
            <h2 class="showcase-title">The operating system for your workforce.</h2>
            
            <!-- Global Value Proposition Subtitle Paragraph -->
            <p class="showcase-subtitle">
                Manage your Philippine workforce through one secure cloud platform.
            </p>
            
            <!-- Minimalist Feature Matrix Grid System Layout Layout -->
            <div class="feature-matrix-grid">
                <div class="matrix-item">
                    <v-icon class="mr-10">payments</v-icon> 
                    <span>Automated Payroll</span>
                </div>
                
                <div class="matrix-item">
                    <v-icon class="mr-10">currency_exchange</v-icon> 
                    <span>Multi-Currency</span>
                </div>

                <div class="matrix-item">
                    <v-icon class="mr-10">badge</v-icon> 
                    <span>HR Suite</span>
                </div>
                
                <div class="matrix-item">
                    <v-icon class="mr-10">fingerprint</v-icon> 
                    <span>FaceAI Attendance</span>
                </div>
                
                <div class="matrix-item">
                    <v-icon class="mr-10">account_balance_wallet</v-icon> 
                    <span>Finance & Expenses</span>
                </div>
                
                <div class="matrix-item">
                    <v-icon class="mr-10">gavel</v-icon> 
                    <span>Compliance & Tax</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlatformShowcase'
}
</script>

<style scoped>
/* Scoped layout styles to guarantee isolation inside parent flex layouts */
.platform-showcase-bg {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    padding: 48px;
    box-sizing: border-box;
}

.showcase-content-wrapper {
    max-width: 520px;
    width: 100%;
    text-align: left;
}

.showcase-title {
    color: #1565C0 !important;
    font-size: 36px !important;
    font-weight: 800 !important;
    line-height: 1.2 !important;
    letter-spacing: -0.04em !important;
    margin-bottom: 16px;
    font-family: 'Inter', sans-serif !important;
}

.showcase-subtitle {
    color: #1565C0 !important;
    font-size: 16px !important;
    line-height: 1.5 !important;
    opacity: 0.8;
    margin-bottom: 40px;
}

/* Feature Grid Structural Matrix Rules Container */
.feature-matrix-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    width: 100%;
}

.matrix-item {
    background: rgba(255, 255, 255, 0.45) !important;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.6) !important;
    border-radius: 12px;
    padding: 16px;
    color: #1565C0 !important;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    box-shadow: 0 4px 12px rgba(21, 101, 192, 0.02) !important;
    transition: transform 0.2s ease, background-color 0.2s ease;
    justify-content: center;
}

/* Soft scale hover response indicator */
.matrix-item:hover {
    background: rgba(255, 255, 255, 0.6) !important;
    transform: translateY(-1px);
}

.matrix-item .v-icon {
    color: #1976D2 !important;
    font-size: 22px !important;
}

</style>
